<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Pengguna</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                <li class="breadcrumb-item active">Basic Tables</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Pengaturan Pengguna</h4>
                  <p class="card-title-desc">
                    Manajemen seluruh pengguna aplikasi Satu Data
                  </p>
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="tambah">Tambah Baru</button>
                </div>
              </div>

              <data-attribut :data="users">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Username</th>
                        <th>Nama</th>
                        <th>Email</th>
                        <th>Perubahan Terakhir</th>
                        <th>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(user, index) in users.data" :key="index">
                        <td scope="row">{{ index+1 }}</td>
                        <td scope="row">{{ user.username }}</td>
                        <td scope="row">{{ user.nama_lengkap }}</td>
                        <td scope="row">{{ user.email }}</td>
                        <td scope="row">{{ (new Date(user.updated_at)).toLocaleString() }}</td>
                        <td scope="row">
                          <a @click="edit(user)" class="p-0 btn btn-sm btn-link">Edit</a> |
                          <a @click="remove(user)" v-if="!user.owner" class="p-0 btn btn-sm btn-link">Hapus</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <form @submit.prevent="action">
  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah' : 'Tambah') + ' Pengguna'"
    backdrop="static" >
    <template #default>
        <div class="mb-3">
          <label for="username" class="form-label">Username</label>
          <input type="text" class="form-control" id="username" required v-model="form.data.username">
        </div>
        <div class="mb-3">
          <label for="nama_lengkap" class="form-label">Nama Lengkap</label>
          <input type="text" class="form-control" id="nama_lengkap" required v-model="form.data.nama_lengkap">
        </div>
        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" class="form-control" id="email" required v-model="form.data.email">
        </div>
        
        <hr>

        <div class="mb-3">
          <label for="roles" class="form-label">Hak Akses</label>
          <select class="form-select" id="roles" v-model="form.data.role_id">
            <option value="">Pilih Roles</option>
            <option :value="role.id" v-for="(role, i) in roles" :key="`role-${i}`" v-text="role.name"></option>
          </select>
        </div>

        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input type="password" class="form-control" id="password" v-model="form.data.password" :required="!!form.id">
        </div>

        <div class="mb-3">
          <label for="konfirm-password" class="form-label">Konfirmasi Password</label>
          <input type="password" class="form-control" id="konfirm-password" v-model="form.data.password_confirm">
        </div>
      </template>
      <template #footer>
        <button type="submit" class="btn btn-success">Simpan</button>
      </template>
    </modal>
  </form>
</template>

<script>
import Layout from '@/layout/Index'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import DataAttribut from '@/components/DataAttribut'
import Modal from '@/components/Modal'

export default {  
  layout: Layout,
  components: { DataAttribut, Modal },
  props: {
    roles: Array,
    filters: Object,
    users: Object,
  },
  data() {
    return {
      form: {
        id: false,
        show: false,
        data: {},
      },
      params: {
        search: this.filters.search,
        role: this.filters.role,
        trashed: this.filters.trashed,
      }
    }
  },
  watch: {
    params: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/users', pickBy(this.params), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    tambah() {
      this.form.show = true;
      this.form.data = {
        role_id: ''
      };
    },
    edit(data) {
      this.form.show = true;
      this.form.id = data.id;
      this.form.data = data;
    },
    action() {
      if (this.form.id) {
        this.$inertia.put('/admin/users/' + this.form.id, this.form.data);
      } else {
        this.$inertia.post('/admin/users', this.form.data);
      }
      this.form.show = false;
      this.form.id = null;
      this.form.urai = '';
      this.form.deskripsi = '';
      this.form.is_published = false;
    },
    remove(row) {
      if(confirm('Konfirmasi Proses Penghapusan?'))
        this.$inertia.delete('/admin/indagindustri/' + row.id);
    },
    reset() {
      this.params = mapValues(this.params, () => null)
    },
  },
}
</script>
